import { render, staticRenderFns } from "./Grafica2.vue?vue&type=template&id=006ad1b1&"
import script from "./Grafica2.vue?vue&type=script&lang=js&"
export * from "./Grafica2.vue?vue&type=script&lang=js&"
import style0 from "./Grafica2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports